import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { LocationApiAdapter } from '../adapters/LocationApiAdapter';
import { LocationService } from '../services/LocationService';

export const useDeleteLocation = () => {
  const queryClient = useQueryClient();

  // 🎯 Memoizar instancias del servicio para evitar recrearlas en cada render
  const locationService = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new LocationApiAdapter(httpClient);
    return new LocationService(apiAdapter);
  }, []);

  return useMutation({
    mutationFn: (id: number) => locationService.deleteLocation(id),
    onSuccess: () => {
      // Invalidar la caché de ubicaciones para refrescar la lista
      queryClient.invalidateQueries({ queryKey: ['locations'] });
    },
  });
}; 